<template>
  <div>
    <Banner />

    <div>
      <CheckLottery6 />
      <ResultWinner6 />
    </div>

    <div class="main">
      <v-container class="bg">
        <v-card class="laseeCard">
          <div style="padding: 10px">
            <CheckLottery12 />
            <ResultWinner12Lasee />
          </div>
        </v-card>
        <NewsSlider />
      </v-container>
      <div class="bg-color"></div>
    </div>
    <Gamepluzzle />
    <DreamSlider />
    <Winner />
    <LineSticker />
    <Downloader />
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer.vue";
import Banner from "../components/Main/Banner.vue";
import ResultWinner6 from "../components/Main/ResultWinner6.vue";
import ResultWinner12Lasee from "../components/Main/ResultWinner12Lasee.vue";
import NewsSlider from "../components/Main/PromoSlider.vue";
import Gamepluzzle from "../components/Main/GamePluzzle.vue";
import DreamSlider from "../components/Main/DreamSlider.vue";
import Winner from "../components/Main/Winner.vue";
import LineSticker from "../components/Main/LineSticker.vue";
import Downloader from "../components/Main/Downloader.vue";
import CheckLottery6 from "../components/Main/CheckLottery6.vue";
import CheckLottery12 from "../components/Main/CheckLottery12.vue";

export default {
  components: {
    CheckLottery6,
    CheckLottery12,
    Footer,
    Downloader,
    LineSticker,
    Winner,
    DreamSlider,
    NewsSlider,
    Gamepluzzle,
    ResultWinner12Lasee,
    ResultWinner6,
    Banner,
  },
  data: () => ({
    //
  }),
};
</script>

<style scoped>
.main {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: end;
  height: 1000px;
}
.laseeCard {
  border-radius: 15px;
  border: 2px solid #00ADEF;
}

@media only screen and (max-width: 959.2px) {
  .main {
    height: 1050px;
  }
}
@media only screen and (max-width: 640px) {
  .main {
    height: 1150px;
  }
}
@media only screen and (max-width: 340px) {
  .main {
    height: 1250px;
  }
}

.bg {
  position: absolute;
  z-index: 1;
}
.bg-color {
  width: 100%;
  height: 1200px;
  background-image: url("../assets/INSEE_PATTERN_FOR CARD.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  clip-path: polygon(
    100% 100%,
    0% 100%,
    0% 41.75%,
    2% 41.49%,
    4% 41.25%,
    6% 41.03%,
    8% 40.84%,
    10% 40.68%,
    12% 40.54%,
    14% 40.44%,
    16% 40.37%,
    18% 40.34%,
    20% 40.34%,
    22% 40.37%,
    24% 40.43%,
    26% 40.53%,
    28% 40.66%,
    30% 40.82%,
    32% 41.01%,
    34% 41.23%,
    36% 41.47%,
    38% 41.73%,
    40% 42.01%,
    42% 42.31%,
    44% 42.62%,
    46% 42.94%,
    48% 43.27%,
    50% 43.61%,
    52% 43.94%,
    54% 44.28%,
    56% 44.6%,
    58% 44.92%,
    60% 45.22%,
    62% 45.51%,
    64% 45.78%,
    66% 46.03%,
    68% 46.25%,
    70% 46.45%,
    72% 46.62%,
    74% 46.76%,
    76% 46.87%,
    78% 46.95%,
    80% 46.99%,
    82% 47%,
    84% 46.98%,
    86% 46.92%,
    88% 46.83%,
    90% 46.71%,
    92% 46.55%,
    94% 46.37%,
    96% 46.16%,
    98% 45.93%,
    100% 45.67%
  );
}
</style>
